import { render, staticRenderFns } from "./ResourceSortSection.vue?vue&type=template&id=095b4f2e&scoped=true&"
import script from "./ResourceSortSection.vue?vue&type=script&lang=ts&"
export * from "./ResourceSortSection.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceSortSection.vue?vue&type=style&index=0&id=095b4f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b4f2e",
  null
  
)

export default component.exports